import { inject } from 'aurelia';
import { getLogger } from '../common/logging';
import { IRouter } from '@aurelia/router';
import { ApiClient } from './api-client';
import { CurrentRoute } from '../current-route';
let log = getLogger('http-service-base');

@inject(ApiClient, IRouter, CurrentRoute)
export class HttpServiceBase {
  constructor(http, router, currentRoute) {
    this.http = http;
    this.router = router;
    this.currentRoute = currentRoute;
  }

  handleError(e) {
    log.error(e);
    if (e.isSuccess) return;

    if (e.statusCode === 401) {
      this.router.load(`/${this.currentRoute.params.customer}/login`);
    }
  }
}
